export async function lookupPincode(pincode) {
  const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
  const data = await res.json();
  const entry = data?.[0];
  if (entry?.Status !== "Success" || !entry.PostOffice?.length) {
    throw new Error("Invalid pincode");
  }
  const offices = entry.PostOffice;
  const first = offices[0];
  return {
    areas: offices.map((o) => ({
      name: (o.Name || "").trim(),
      taluk: o.Taluk || o.Division || "",
      district: o.District || "",
      state: o.State || "",
      delivery: o.DeliveryStatus === "Delivery",
    })),
    district: first.District || "",
    state: first.State || "",
  };
}
